import { render, staticRenderFns } from "./FreeAccountExpired.vue?vue&type=template&id=566efb7e&scoped=true"
import script from "./FreeAccountExpired.vue?vue&type=script&lang=js"
export * from "./FreeAccountExpired.vue?vue&type=script&lang=js"
import style0 from "./FreeAccountExpired.vue?vue&type=style&index=0&id=566efb7e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566efb7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('566efb7e')) {
      api.createRecord('566efb7e', component.options)
    } else {
      api.reload('566efb7e', component.options)
    }
    module.hot.accept("./FreeAccountExpired.vue?vue&type=template&id=566efb7e&scoped=true", function () {
      api.rerender('566efb7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/FreeAccountExpired.vue"
export default component.exports